import React from "react";
import { useParams } from "react-router-dom";
import { pricingPlans } from "../Data";
import "./DetailPricing.css";

const DetailPricing = () => {
  const { planId } = useParams();
  const plan = pricingPlans.find(p => p.id === planId);

  if (!plan) return <h1 className="noPricing">Plan not found</h1>;

  return (
    <section className="detailPricingSection">
      <div className="detailPricingWrapper">
        
        <h1 className="detailPricingTitle">{plan.title}</h1>
        <p className="detailPricingTag">{plan.tag}</p>

        <div className="detailPricingPrice">
          <span className="detailPriceValue">{plan.price}</span>
          <span className="detailPriceFrequency">{plan.frequency}</span>
        </div>

        <p className="detailPricingSubtitle">{plan.subtitle}</p>

        {plan.features.length > 0 && (
          <ul className="detailPricingList">
            {plan.features.map((feature, index) => (
              <li key={index} className="detailPricingItem">
                <span className="detailCheck">✓</span>
                {feature.text}
              </li>
            ))}
          </ul>
        )}

      </div>
    </section>
  );
};

export default DetailPricing;
